module.exports = __webpack_public_path__ + "img/ai_main.b073529f.png";